module.exports = __webpack_public_path__ + "img/bg3.3a480ab9.png";